module.exports = __webpack_public_path__ + "static/media/Molluscs.04ccfddc.jpg";